import { useCallback, useEffect, useState } from "react";

import { oids } from "@/configs/Settings";
import { useSessionContext } from "@/contexts/SessionContext";

import { listSncrNumeracaoBlocos } from "../services/sncrNumeracaoBasicService";

type Options = {
  refreshKey?: boolean | number | string;
  enabled?: boolean;
};

export function useSncrDisponiveisCount({
  refreshKey,
  enabled = true,
}: Options = {}) {
  const { user } = useSessionContext();
  const [disponiveis, setDisponiveis] = useState<number | null>(null);
  const [loading, setLoading] = useState(false);

  const practitionerReference = user?.username
    ? `Practitioner/${oids.cpf}-${user.username}`
    : undefined;

  const reload = useCallback(async () => {
    if (!enabled) return;
    setLoading(true);
    try {
      const list = await listSncrNumeracaoBlocos({
        practitionerReference,
      });
      setDisponiveis(
        list.reduce((acc, bloco) => acc + bloco.disponiveis.length, 0),
      );
    } catch {
      setDisponiveis(null);
    } finally {
      setLoading(false);
    }
  }, [enabled, practitionerReference]);

  useEffect(() => {
    void reload();
  }, [reload, refreshKey]);

  return { disponiveis, loading, reload };
}
